export default __webpack_public_path__ + "static/avatar-tag-do-dark-a133dc05cb2993cc5b25d83b1af35f5e.png";